import React from 'react';
import numeral from 'numeral';
import InvestItemSC from './invest-item.styled';
import { SmallText, BodyText } from '../../../typography';
import Mark from '../../../ui/mark';
import dlt from '../../../../utils/default-lang';
import { FormattedMessage } from 'react-intl';
import Moment from 'react-moment';

const InvestItem = ({
  date,
  maxInvestment,
  reinvest,
  isTablet,
  type,
  totalAmount,
  amount,
  isFirstChange,
  isFirstDeposit,
}) => {
  return (
    <InvestItemSC>
      <td>
        <BodyText className="bolder">
          {type === 'investment_instruction_change' && isFirstChange ? (
            <FormattedMessage
              id="investor_invest_manage_invest_table_change_first"
              defaultMessage={dlt['investor_invest_manage_invest_table_change_first']}
            />
          ) : type === 'investment_instruction_change' ? (
            <FormattedMessage
              id="investor_invest_manage_invest_table_change"
              defaultMessage={dlt['investor_invest_manage_invest_table_change']}
            />
          ) : type === 'deposit' && isFirstDeposit ? (
            <FormattedMessage
              id="investor_invest_manage_invest_table_deposit_first"
              defaultMessage={dlt['investor_invest_manage_invest_table_deposit_first']}
            />
          ) : type === 'deposit' ? (
            <FormattedMessage
              id="investor_invest_manage_invest_table_deposit"
              defaultMessage={dlt['investor_invest_manage_invest_table_deposit']}
            />
          ) : (
            <FormattedMessage
              id="investor_invest_manage_invest_table_withdrawal"
              defaultMessage={dlt['investor_invest_manage_invest_table_withdrawal']}
            />
          )}
        </BodyText>

        {isTablet ? (
          <BodyText>
            <Moment parse="DD.MM.YYYY" format="DD. MMMM YYYY">
              {date}
            </Moment>
          </BodyText>
        ) : null}
      </td>

      {isTablet ? null : (
        <td>
          <BodyText className="bolder">
            <Moment parse="DD.MM.YYYY" format="DD. MMMM YYYY">
              {date}
            </Moment>
          </BodyText>
        </td>
      )}

      <td>
        {type === 'investment_instruction_change' ? (
          <SmallText className="bolder">
            <Mark colorStyle={reinvest ? 'GREEN' : 'RED'}>
              {reinvest ? (
                <>
                  <FormattedMessage id="global_on" defaultMessage={dlt['global_on']} />{' '}
                  <span className="additional-info">({Number(reinvest) * 100} %)</span>
                </>
              ) : (
                <FormattedMessage id="global_off" defaultMessage={dlt['global_off']} />
              )}
            </Mark>
          </SmallText>
        ) : null}
        {isTablet ? (
          <>
            {' '}
            {type === 'investment_instruction_change' ? <br /> : null}
            {type === 'investment_instruction_change' ? (
              <BodyText>
                <b>{numeral(Number(maxInvestment)).format('0,00.00')} €</b>
              </BodyText>
            ) : type === 'deposit' ? (
              <BodyText>
                <b>{numeral(totalAmount).format('0,00.00')} €</b>
              </BodyText>
            ) : (
              <BodyText>
                <b>{numeral(amount).format('0,00.00')} €</b>
              </BodyText>
            )}
          </>
        ) : null}
      </td>
      {isTablet ? null : (
        <td>
          {type === 'investment_instruction_change' ? (
            <BodyText>
              <span className="desc">
                <FormattedMessage
                  id="investor_invest_manage_invest_table_max_invest"
                  defaultMessage={dlt['investor_invest_manage_invest_table_max_invest']}
                />
              </span>{' '}
              <b>{numeral(Number(maxInvestment)).format('0,00.00')} €</b>
            </BodyText>
          ) : type === 'deposit' ? (
            <BodyText>
              <span className="desc">
                <FormattedMessage
                  id="investor_invest_manage_invest_table_deposit_amount"
                  defaultMessage={dlt['investor_invest_manage_invest_table_deposit_amount']}
                />
              </span>{' '}
              <b>{numeral(totalAmount).format('0,00.00')} €</b>
            </BodyText>
          ) : (
            <BodyText>
              <span className="desc">
                <FormattedMessage
                  id="investor_invest_manage_invest_table_withdrawal_amount"
                  defaultMessage={dlt['investor_invest_manage_invest_table_withdrawal_amount']}
                />
              </span>{' '}
              <b>{numeral(amount).format('0,00.00')} €</b>
            </BodyText>
          )}
        </td>
      )}
    </InvestItemSC>
  );
};

export default InvestItem;
